import React from 'react';
import moment from 'moment';
import filesize from 'filesize';

import MaterialIcon from 'material-icons-react';

import {
  Flex,
  Text,
  Link,
  FlexEnd,
  Button,
  ButtonLabel,
  ItemContain,
  PrimaryLine,
  SecondaryLine
} from './Styled';

import { getDocumentDownloadLink } from 'utils';

export const OrderDocument = ({ id, size, orderId, created_on, description }) => (
  <Link target={'_blank'} href={getDocumentDownloadLink(orderId, id)}>
    <ItemContain>
      <Flex>
        <MaterialIcon size={38} icon="file_copy" color={'rgb(0,118,190)'} />

        <Text style={{ marginLeft: 8 }}>
          <PrimaryLine>{description}</PrimaryLine>

          <SecondaryLine fontWeight={300}>
            <span>Uploaded - {moment(created_on).format('dddd Do MMMM YYYY')}</span>
            <span>{!!size && `, File Size - ` + filesize(size).toLowerCase()}</span>
          </SecondaryLine>
        </Text>

        <FlexEnd>
          <Button secondary>
            {' '}
            <MaterialIcon size={24} icon="cloud_download" color={'rgb(20,76,110)'} />
            <ButtonLabel>Download</ButtonLabel>
          </Button>
        </FlexEnd>
      </Flex>
    </ItemContain>
  </Link>
);

export default OrderDocument;
